// extracted by mini-css-extract-plugin
export default {"card":"components-general-smart-insights-list-list-card-smart-insights-module__card","bullet":"components-general-smart-insights-list-list-card-smart-insights-module__bullet"};